export default "__VITE_ASSET__5b2cda5f__"